<template>
   <form class="container ">
        <div class="form-group">
            <label>Name</label>
            <input type="text" class="form-control" v-model="name" >
        </div>
        <div class="form-group">
            <label>Occupation</label>
            <input type="text" class="form-control" v-model="currentPost" >
        </div>
        <div class="form-group">
          <label>For user:</label>
          <div>
            <select
              class="form-select"
              aria-label="Default select example"
              v-model="selectedUserEmail"
            >
              <option selected disabled>select user</option>
              <option v-for="(adminEmail, index) in adminsEmail" :key="index">{{ adminEmail }}</option>
            </select>
          </div>
        </div>
        <!-- <div class="form-group">
            <label >Image</label>
            <input type="file" class="form-control"  @change="setImage">
        </div>
        <div class="form-group">
            <label for="exampleInputPassword1">Description</label>
            <textarea type="text" class="form-control" v-model="this.decreption" ></textarea>
        </div> -->
        <button type="submit" class="btn btn-light me-2" @click.prevent="addBlog" >Create</button>
        <button type="button" class="btn btn-light" v-on:click="$emit('toggle')">Cancel</button>
    </form> 
</template>
<script>
import axios from 'axios'
import APIs from './../../../../config'
export default {
    name: "AddBlog" ,
    data(){
        return {
            name : "" , 
            currentPost : "" , 
            selectedUserEmail: "",

            adminsEmail: "",
            decreption: "",
        }
    },
    created() {
        this.getAllAdminsEmail()
    },
    methods : {
        setImage(event){
            this.image = event.target.files[0]
        },
        getAllAdminsEmail() {
          var get_token = localStorage.getItem('token')
          var user_id = localStorage.getItem('user_id')

          axios.get(`${APIs.API_URL}/superAdmin/adminEmailList/${user_id}`,{
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${get_token}`
              }
          })
          .then(res => {
              this.adminsEmail = res.data.map(data => data.email)
          }).catch(error => {
              console.error(error)
          })
        },
        addBlog(){
            // const fd = new FormData()
            // fd.append('BlogImg' , this.image)
            // fd.append('title' , this.title)
            // fd.append('description' , this.decreption)
            let formData = {
                name: this.name,
                currentPost: this.currentPost,
                email: this.selectedUserEmail
            }

            var get_token = localStorage.getItem('token')
            var user_id = localStorage.getItem('user_id')
            axios.post(`${APIs.API_URL}/card/cardData/${user_id}`, formData,
                {
                    headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${get_token}`
                }
            } )
            .then(() => {
                   this.$swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: "Added",
                    showConfirmButton: false,
                    timer: 1500
                });
                this.$emit("refresh")
            })
            .catch( (error) => {
                this.$swal.fire({
                    position: 'top-end',
                    icon: 'error',
                    title: error.response.data.error,
                    showConfirmButton: false,
                    timer: 1500
                });
            });
            
        }
    }
}
</script>

<style scoped lang="scss">
    input {
        width: 80%;
    }
    select {
        width: 80%;
    }
</style>
